export default "__VITE_ASSET__BEKLjGOa__"